export default {
  title: 'Witaj',
  subtitle: 'Zaloguj się, aby zarządzać kontem i zamówieniami',
  benefits: {
    earn_points: {
      title: 'Zbieraj punkty przy każdym zamówieniu',
      description: 'Zbieraj punkty i odblokowuj ekskluzywne nagrody',
    },
    get_deals: {
      title: 'Otrzymuj ekskluzywne zniżki',
      description: 'Używaj punktów, aby otrzymać darmowe produkty',
    },
    redeem_points: {
      title: 'Wymieniaj punkty na darmowe jedzenie',
      description: 'Zyskaj dostęp do promocji tylko dla członków',
    },
  },
};
